import React from "react"
import { Link } from 'react-router-dom'

const MenuElement = (props) => { //#6200ee
    return <Link to={props.link}>
        <li className="mdc-list-item" tabIndex="0" id="menuItem" style={{ marginLeft: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", margin: "0px 0px"}} id={"li" + props.mid}>
            <div style={{ height: "40px", width: "6px", backgroundColor: "#1B1D1E", marginLeft: "-8px", marginRight: "10px" }} id={"block" + props.mid}></div>
            <span className="mdc-list-item__ripple"></span>
            <i className={props.icon + " mdc-list-item__graphic fa-lg"}></i>
            <span className="mdc-list-item__text">{props.text}</span>
        </li>
    </Link>
}

const MenuElementExternalLink = (props) => { //#6200ee 
    return <a href={props.link} target="_blank">
        <li className="mdc-list-item" tabIndex="0" id="menuItem" style={{ marginLeft: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", margin: "0px 0px"}} id={"li" + props.mid}>
            <div style={{ height: "40px", width: "6px", backgroundColor: "#1B1D1E", marginLeft: "-8px", marginRight: "10px" }} id={"block" + props.mid}></div>
            <span className="mdc-list-item__ripple"></span>
            <i className={props.icon + " mdc-list-item__graphic fa-lg"}></i>
            <span className="mdc-list-item__text">{props.text}</span>
        </li>
    </a>
}

const MenuHeader = (props) => { 
    return <h3 className="mdc-list-group__subheader" style={{marginBottom: '8px'}}>{props.text}</h3>
}


class SideMenu extends React.Component {

    componentDidMount() {
        var els = document.getElementsByClassName('mdc-list-item')
        for (const i in els) {
            try {
                var e = els[i] 
                var mid = e.getAttribute("id").split("li")[1]
                e.onclick = new Function(`
                console.log(${mid})
try{
                document.getElementsByClassName("mactl")[0].style.backgroundColor = "#181A1B";
                document.getElementsByClassName("mactl")[0].classList.remove("mactl");
                document.getElementsByClassName("mactb")[0].style.backgroundColor = "#1B1D1E";
                document.getElementsByClassName("mactb")[0].classList.remove("mactb");
} catch (e){console.log(e)}          
                document.getElementById("block${mid}").style.backgroundColor = "#6200ee";
                document.getElementById("block${mid}").classList.add("mactb");
                document.getElementById("li${mid}").classList.add("mactl");
                document.getElementById("li${mid}").style.backgroundColor = "#1B1D1E";
                `)

            }
            catch{ }
        }
    }

    render(props) {
        return <aside className="mdc-drawer mdc-top-app-bar--fixed-adjust" id="sideMenu" style={{ backgroundColor: "#181a1b", borderRightWidth: "0px", transition: "transform .4s ease 0s, opacity .2s ease 0s" }}>
            <div className="mdc-drawer__content">
                <div className="mdc-list-group">
                    <MenuHeader text="Аккаунт" />
                    <ul className="mdc-list">
                        <MenuElement link="/cabinet" text="Кабинет" icon="fas fa-user" mid="0" />
                        <MenuElement link="/partners" text="Партнёры" icon="fas fa-user-friends" mid="1" />
                        <MenuElement link="/settings" text="Настройки" icon="fas fa-cog" mid="2" />
                    </ul>

                    <MenuHeader text="Услуги" />
                    <ul className="mdc-list">
                        <MenuElement link="/boost" text="Продвижение" icon="fas fa-chart-line" mid="3" />
                        <MenuElement link="/televiews" text="Автопросмотры" icon="fas fa-eye" mid="4" />
                        
                    </ul> 
 
                  
                    <MenuHeader text="Обратная связь" />
                    <ul className="mdc-list">
                        <MenuElementExternalLink link="https://t.me/suppntbot"  text="Поддержка" icon="fab fa-telegram-plane" mid="6" />
                        <MenuElement link="/api-reference" text="Документация API" icon="fas fa-code" mid="7" />
                        
                    </ul>
                </div>
            </div>
        </aside>
    }
}

export default SideMenu

/* <MenuElement link="/parsing" text="Парсинг" icon="fas fa-code" mid="6" />
<MenuElement link="/rent" text="Аренда SIM" icon="fas fa-sim-card" mid="7" />
<MenuElement link="/proxy" text="Прокси" icon="fas fa-server" mid="8" /> 

 <MenuElement link="/telemailer" text="TeleMailer" icon="fas fa-envelope" mid="5" />
                         <MenuElement link="/telesearch" text="TeleSearch" icon="fas fa-search" mid="6" />
                         */